import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(() => ({
  root: {
    color: '#f7f6e7',
    backgroundColor: '#314e52',
    padding: 10,
  },
  button: {
    "&:hover": {
      background: 'none',
      color: '#f7f6e7',
    }
  }
}));

export default function Footer() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="body2" align="center">
        Copyright © Gattino Lab LLC
      </Typography>
      <Button color="inherit" className={classes.button} href={"mailto:gattinolab@gmail.com"}>
        <Typography variant="body2" align="center">
          EMAIL US
        </Typography>
      </Button>
    </div>
  );
}
